/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlSSOStartLoginResponse
 */
export interface ControlSSOStartLoginResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlSSOStartLoginResponse
     */
    auth0_url: string;
}

/**
 * Check if a given object implements the ControlSSOStartLoginResponse interface.
 */
export function instanceOfControlSSOStartLoginResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "auth0_url" in value;

    return isInstance;
}

export function ControlSSOStartLoginResponseFromJSON(json: any): ControlSSOStartLoginResponse {
    return ControlSSOStartLoginResponseFromJSONTyped(json, false);
}

export function ControlSSOStartLoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSSOStartLoginResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'auth0_url': json['auth0_url'],
    };
}

export function ControlSSOStartLoginResponseToJSON(value?: ControlSSOStartLoginResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'auth0_url': value.auth0_url,
    };
}

